module.exports = __webpack_public_path__ + "static/media/marginalia-uploading.9e365e81.svg";